import PropTypes from 'prop-types';
import React from 'react';
import Cropper from 'react-cropper';
import './style.css';

export interface ImageCroppeProps {
  src: string;
  aspectRatio: number;
  crop: (dataUrl: string) => void;
}

const style = {
  height: 400,
  width: '100%',
};

const ImageCropper = ({ src, aspectRatio, crop }: ImageCroppeProps) => {
  const cropperRef = React.useRef(null);

  const onCrop = () => {
    const cropper: Cropper = cropperRef.current.cropper;

    const cropBoxData = cropper.getCropBoxData();

    const canvas = cropper.getCroppedCanvas({
      width: cropBoxData.width,
      height: cropBoxData.height,
    });

    const dataUrl = canvas.toDataURL('image/webp');

    crop(dataUrl);
  };

  return <Cropper src={src} style={style} aspectRatio={aspectRatio} guides={false} ref={cropperRef} crop={onCrop} />;
};

ImageCropper.propTypes = {
  src: PropTypes.string,
  crop: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number.isRequired,
};

// eslint-disable-next-line import/no-default-export
export default ImageCropper;
